import React, { useEffect } from 'react';
import Moment from 'moment';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { useMsal } from '@azure/msal-react';
// import { makeStyles } from '@mui/styles';
import ActionNba from './assets/fonts/ActionNBA-Medium-Web.woff2';
import { InteractionStatus, InteractionRequiredAuthError } from '@azure/msal-browser';
import { isSafari, isMobileSafari } from 'react-device-detect';
import BrowserSnackbars from './sharedcomponents/snackbar/browserSnackBar';
// import Header from './components/Header/Header';
// import InnerRouter from './router/InnerRouter';
// import NavBar from './components/Nav/NavBar/NavBar';
// import Headroom from 'react-headroom';
// import { useAuthState } from './stores/authStore';
import { useThemeState } from './hookState/ThemeState';
// import ModuleDrawer from './modules/Module/moduleDrawer';
// import { useModuleDrawerState } from './hookState/ModuleDrawerState';
import Main from './Main';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Helper from './utility/helper';
// import { getDetails } from './stores/authStore';

import { loginRequest } from './config/authConfig';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Privacy_Policy from './pages/Privacy-Policy';


// const useStyles = makeStyles(() => ({
//     containermaxwidth: {
//         maxWidth: '1440px',
//         boxShadow: '0px 5px 15px #999',
//         padding: 0,
//     }
// }));
function App() {
    // const classes = useStyles();
    const { instance, inProgress, accounts } = useMsal();
    // const isAuthenticated = useIsAuthenticated();
    // const authState = useAuthState();
    const themeState = useThemeState();
    const [showLogin, setShowLogin] = React.useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'success',
        message: '',
    });
    //added below setSsoLoginInProgress flag to rerender page
    const [ssoLoginInProgress, setSsoLoginInProgress] = React.useState(null);
    // const moduleDrawerState = useModuleDrawerState();

    let theme = createTheme({
        palette: {
            primary: {
                main: '#17408B',
            },
            header: {
                main: themeState.header.value
                    ? themeState.header.value
                    : '#17408B',
            },
            secondary: {
                main: themeState.secondary.value
                    ? themeState.secondary.value
                    : '#C9082A',
            },
            common: {
                white: '#FFF',
            },
        },
        components: {
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        minWidth: 30,
                        color: '#fff',
                    },
                },
            },
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        padding: 0,
                    },
                },
            },
            MuiListItemText: {
                styleOverrides: {
                    primary: {
                        // fontFamily:
                        //     'Action NBA, Roboto, Helvetica, Arial, sans-serif',
                        // color: '#FFF',
                        color: themeState.leftnav.value,
                        fontSize: 13.5,
                        fontStyle: 'normal',
                        fontWeight: 600,
                        opacity: 1,
                        textTransform: 'capitalize',
                        fontFamily: 'Lato',
                    },
                },
            },
            MuiToolbar: {
                styleOverrides: {
                    root: {
                        height: 70,
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: 'primary.main',
                    },
                },
            },
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        zIndex: 0
                    }
                }
            },
            MuiAvatar: {
                styleOverrides: {
                    img: {
                        objectFit: 'contain',
                    },
                },
            },
            MuiCssBaseline: {
                styleOverrides: `
                  @font-face {
                    font-family: 'Action NBA';
                    font-style: normal;
                    font-weight: normal;
                    font-size: 38px;
                    src: local('Action NBA'), url(${ActionNba}) format('woff2');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
                  }
                `,
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '4px', // this needs to check using spacing
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: '4px', // this needs to check using spacing
                    },
                },
            },
        },
    });

    useEffect(() => {
        // console.log('authState : ', authState);
        // console.log(
        //     'authState.isLoggedIn.value : ',
        //     authState.isLoggedIn.value
        // );
        // if (!authState.isLoggedIn.value) {
        //     login();
        // }
        // console.log('process.env:', process.env);
        // eslint-disable-next-line no-debugger
        //debugger
        //console.log('accounts', accounts)
        if (instance && accounts[0]) {
            // eslint-disable-next-line no-debugger
            //debugger
            const accessTokenRequest = {
                ...loginRequest,
                account: accounts[0],
            }
            if (inProgress === InteractionStatus.None) {
                instance
                    .acquireTokenSilent(accessTokenRequest)
                    .then(async (response) => {
                        // console.log(response);
                        setShowLogin(false);
                        Helper.setStorage('accessToken', response.accessToken);
                        Helper.setStorage('chk', 'aad');
                        Helper.removeStorage('SSOLoginInProgress');
                        // eslint-disable-next-line no-debugger
                        // debugger
                        //added below setSsoLoginInProgress flag to rerender page
                        setSsoLoginInProgress(null);
                        Helper.reloadPage();
                        // window.location.reload();
                        //await getDetails();
                        // return false;
                    })
                    .catch(error => {
                        console.log('inside catch token error');
                        if (error instanceof InteractionRequiredAuthError) {
                            console.log('inside this token error redirect call');
                            instance.acquireTokenRedirect(accessTokenRequest);
                        }
                    });
            }
        }
        else if (Helper.getStorage('chk') == null && inProgress === InteractionStatus.Startup) {
            Helper.setStorage('SSOLoginInProgress', 'start', 60 * 5);
            setSsoLoginInProgress('start')
            setShowLogin(false);
        }
    }, [instance, accounts, inProgress]);

    useEffect(() => {
        setTimeout(() => {
            if (Helper.getStorage('accessToken') == null) {
                setShowLogin(true);
            }
            if (isSafari || isMobileSafari) {
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'We recommend using Google Chrome for the optimal experience of LETSGO. Chrome offers excellent performance, security, and compatibility with our features.',
                });
            }
        }, 2000);

    }, [])
    return (
        <ThemeProvider theme={theme}>
            <Box>
                {/* <Container maxWidth="lg" classes={{ maxWidthLg: classes.containermaxwidth }}> */}
                <Router getUserConfirmation={() => {

                }}>
                    <CssBaseline />
                    {showLogin && Helper.getStorage('accessToken') == null && Helper.getStorage('chk') == null && Helper.getStorage('SSOLoginInProgress') == null && location.pathname.indexOf('/signup') == -1 ?
                        (
                            <Login setLogin={setShowLogin} />
                        )
                        :
                        showLogin && Helper.getStorage('chk') != 'jr' && Helper.getStorage('accessToken') != null && Helper.getStorage('SSOLoginInProgress') == null && location.pathname.indexOf('/signup') == -1 ?
                            // <UnauthenticatedTemplate>
                            <Login setLogin={setShowLogin} />
                            // </UnauthenticatedTemplate>
                            : null
                    }
                    {Helper.getStorage('chk') == 'jr' || Helper.getStorage('chk') == 'aad' ?
                        <Main themeState={themeState} />
                        : null
                    }
                    {
                        Helper.getStorage('accessToken') == null && Helper.getStorage('chk') == null && location.pathname.indexOf('/signup') > -1
                            ? <Signup />
                            : null
                    }

                    <Route exact path='/forgotpassword'>
                        <ForgotPassword setLogin={setShowLogin} />
                    </Route>
                    {
                        Helper.getStorage('accessToken') == null && Helper.getStorage('chk') == null && location.pathname.indexOf('/resetPassword') > -1
                            ? <ResetPassword setLogin={setShowLogin} />
                            : null
                    }

                    <Route exact path='/privacy-policy'>
                        <Privacy_Policy setLogin={setShowLogin} />
                    </Route>

                    {/* {Helper.getStorage('accessToken') == null && showLogin ? (
                        location.pathname.indexOf('/signup') > -1 ? (
                            <Signup />
                        ) : (
                            <Login setLogin={setShowLogin} />
                        )
                    ) : (
                        <Main themeState={themeState} />
                    )} */}
                    {/* <Headroom>
                        <Header />
                    </Headroom>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                // flexDirection: 'row',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row',
                                },
                                marginTop: '70px',
                            }}>
                            <Box
                                sx={{
                                    display: {
                                        xs: 'none',
                                        md: 'block',
                                    },
                                }}>
                                <NavBar />
                            </Box>
                            <Box>
                                {moduleDrawerState.open.value ? (
                                    <ModuleDrawer
                                        modules={moduleDrawerState.modules.get()}
                                    />
                                ) : null}
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    width: '100%',
                                    backgroundColor:
                                        themeState.appbackground.value,
                                    // height: 'calc(100vh - 72px)',
                                    overflowY: 'auto',
                                    p: 2,
                                }}>
                                {authState && authState.isLoggedIn.value ? (
                                    <InnerRouter />
                                ) : null}
                            </Box>
                        </Box>
                    </Box> */}
                    {/* <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Headroom>
                                <Header />
                            </Headroom>
                        </Grid>
                        <Grid
                            item
                            md={3}
                            lg={2}
                            sx={{
                                display: {
                                    xs: 'none',
                                    md: 'block',
                                },
                            }}>
                            <NavBar />
                        </Grid>
                        <Grid item xs={12} md={9} lg={10} width="100%">
                            <InnerRouter />
                        </Grid>
                    </Grid> */}
                </Router>
                {/* </Container> */}
            </Box>
            {snackBarProps.openSnack && (
                <BrowserSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></BrowserSnackbars>
            )}
        </ThemeProvider>
    );
}

export default App;
